const { stringify, parse } = JSON;
export function cloneArray(data) {
    return parse(stringify(data));
}
//# sourceMappingURL=clone.js.map